module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.dialogVisible,
      "destroy-on-close": "",
      "before-close": _vm.handleClose,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.formLoading),
      expression: "formLoading"
    }],
    ref: "modelForm",
    attrs: {
      "model": _vm.modelForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.modelFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择型号"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.selectLoading
    },
    on: {
      "change": _vm.selectModel
    },
    model: {
      value: (_vm.modelForm.model),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "model", $$v)
      },
      expression: "modelForm.model"
    }
  }, _vm._l((_vm.modelList), function(item) {
    return _c('el-option', {
      key: item.modelId,
      attrs: {
        "label": item.modelName,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "型号名称",
      "prop": "modelName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.modelName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "modelName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.modelName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "型号ID",
      "prop": "modelId"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.modelId),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "modelId", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.modelId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "小程序型号",
      "prop": "modelList"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "textarea"
    },
    model: {
      value: (_vm.modelForm.modelList),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "modelList", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.modelList"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否默认"
    }
  }, [_c('el-switch', {
    attrs: {
      "activeValue": 1,
      "inactiveValue": 0
    },
    model: {
      value: (_vm.modelForm.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "isDefault", $$v)
      },
      expression: "modelForm.isDefault"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-3cf0b350","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/modelAdapter/components/edit.vue
// module id = 1647
// module chunks = 0